import {Button as PeacockButton} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IButtonProps} ButtonProps
 * @property {boolean} [disabled] When true, button is rendered in disabled mode.
 * @property {string | import('react').SVGProps<SVGSVGElement>} [iconTrailing] Trailing icon rendered after button label.
 * @property {string | import('react').SVGProps<SVGSVGElement>} [iconLeading] Leading icon rendered before button label.
 * @property {string} [text] Text value to display on button (can be used with or instead of children).
 * @property {'small' | 'medium' | 'large'} [size] Button size.
 * @property {'primary' | 'secondary' | 'auxiliary' | 'tertiary' | 'danger' | 'primaryDanger' | 'secondaryDanger' | 'tertiaryDanger' | 'primaryInverse' | 'secondaryInverse' | 'auxiliaryInverse' | 'tertiaryInverse' | 'dangerInverse'} [variant] Button visual variant.
 * @property {boolean} [isLoading] When true, button is rendered in loading mode.
 * @property {string} [loadingText] Text to display while loading.
 * @property {boolean} [skeleton] Renders skeleton state.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 * @property {import('react').ReactNode} [children] Button content.
 * @property {'button' | 'submit' | 'reset'} [type] Native button type.
 * @property {import('react').MouseEventHandler<HTMLButtonElement>} [onClick] Click handler.
 * @property {string} [className] Additional CSS classes.
 */

/**
 * Wrapper around Peacock DS Button.
 * Supports all Peacock DS button props.
 * @param {ButtonProps} props
 */
export const Button = props => {
  return <PeacockButton {...props} />
}
